import Vue from 'vue'
import Router from 'vue-router'
import WxTokenGetter from '../components/wx-token-getter'
import WxLogin from '../components/wx-login'
import logout from '../components/logout'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/ams/',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: resolve => require(['../pages/Login'], resolve),
      meta: {title: '登录', hideBack: true}
    },
    {
      path: '/',
      component: resolve => require(['../pages/Main'], resolve),
      meta: {auth: true}, // 是否需要认证
      children: [
        {
          path: '',
          name: 'Home',
          component: resolve => require(['../pages/Main/Home'], resolve),
          meta: {
            auth: true /* 是否需要认证 */, title: '首页', hideBack: true
          }
        },
        {
          path: '/room_repair',
          name: 'Room',
          component: resolve => require(['../pages/Main/Room/RoomRepair'], resolve),
          meta: {
            auth: true, title: '房屋报修'
          }
        },
        {
          path: '/room_repair/:id',
          name: 'RoomRepair',
          component: resolve => require(['../pages/Main/Room/Repair/Show'], resolve),
          meta: {
            auth: true, title: '房屋报修'
          }
        },
        {
          path: '/facility',
          name: 'Facility',
          component: resolve => require(['../pages/Main/Facility'], resolve),
          meta: {
            auth: true /* 是否需要认证 */, title: '功能', hideBack: true
          }
        },
        {
          path: '/facility/user/dept_csmb_query',
          name: 'DeptCsmbQuery',
          component: resolve => require(['../pages/Main/Facility/User/DeptCsmbQuery'], resolve),
          meta: {
            auth: true, title: '库存查询'
          }
        },
        {
          path: '/facility/user/dept_csmb_use',
          name: 'DeptCsmbUse',
          component: resolve => require(['../pages/Main/Facility/User/CsmbUse'], resolve),
          meta: {
            auth: true, title: '耗材使用'
          }
        },
        {
          path: '/facility/user/dept_csmb_used',
          name: 'DeptCsmbUsed',
          component: resolve => require(['../pages/Main/Facility/User/CsmbUsed'], resolve),
          meta: {
            auth: true, title: '使用记录'
          }
        },
        {
          path: '/facility/user/dept_csmb_use/use_detail/:id',
          name: 'DeptCsmbUseDetail',
          component: resolve => require(['../pages/Main/Facility/User/CsmbUse/UseDetail'], resolve),
          meta: {
            auth: true, title: '使用详情'
          }
        },
        {
          path: '/facility/user/csmb_in',
          name: 'DeptCsmbIn',
          component: resolve => require(['../pages/Main/Facility/User/CsmbIn'], resolve),
          meta: {
            auth: true, title: '耗材入科'
          }
        },
        {
          path: '/facility/user/csmb_in/dept_requisition/:id',
          name: 'DeptRequisition',
          component: resolve => require(['../pages/Main/Facility/User/CsmbIn/DeptRequisition'], resolve),
          meta: {
            auth: true, title: '未确认批次'
          }
        },
        {
          path: '/facility/user/csmb_direct',
          name: 'DeptCsmbDirect',
          component: resolve => require(['../pages/Main/Facility/User/CsmbDirect'], resolve),
          meta: {
            auth: true, title: '直购入科'
          }
        },
        {
          path: '/facility/user/csmb_direct_op',
          name: 'DeptCsmbDirectOp',
          component: resolve => require(['../pages/Main/Facility/User/CsmbDirectOp'], resolve),
          meta: {
            auth: true, title: '手术耗材'
          }
        },
        {
          path: '/facility/user/csmb_direct/batch_approval/:id',
          name: 'DeptCsmbDirectBatchApproval',
          component: resolve => require(['../pages/Main/Facility/User/CsmbDirect/CsmbDirectBatchApproval'], resolve),
          meta: {
            auth: true, title: '未确认直购批次'
          }
        },
        {
          path: '/facility/user/csmb_direct/op_add/:id',
          name: 'DeptCsmbDirectOpAdd',
          component: resolve => require(['../pages/Main/Facility/User/CsmbDirect/CsmbDirectOpAdd'], resolve),
          meta: {
            auth: true, title: '追加入科'
          }
        },
        {
          path: '/facility/user/csmb_remind',
          name: 'DeptCsmbRemind',
          component: resolve => require(['../pages/Main/Facility/User/CsmbRemind'], resolve),
          meta: {
            auth: true, title: '过期提醒'
          }
        },
        {
          path: '/facility/user/csmb_remind/:id',
          name: 'DeptCsmbBatchRemind',
          component: resolve => require(['../pages/Main/Facility/User/CsmbRemind/CsmbBatchRemind'], resolve),
          meta: {
            auth: true, title: '过期批次'
          }
        },
        {
          path: '/facility/user/csmb_inventory',
          name: 'DeptCsmbInventory',
          component: resolve => require(['../pages/Main/Facility/User/CsmbInventory'], resolve),
          meta: {
            auth: true, title: '盘点'
          }
        },
        {
          path: '/facility/user/csmb_inventory/add',
          name: 'DeptCsmbInventoryAdd',
          component: resolve => require(['../pages/Main/Facility/User/CsmbInventory/add'], resolve),
          meta: {
            auth: true, title: '新的盘点'
          }
        },
        {
          path: '/facility/user/csmb_inventory/check/:id/:batchId/:consumableId',
          name: 'DeptCsmbInventoryCheck',
          component: resolve => require(['../pages/Main/Facility/User/CsmbInventory/check'], resolve),
          meta: {
            auth: true, title: '科室盘点'
          }
        },
        {
          path: '/facility/user/csmb_inventory/:id',
          name: 'DeptCsmbInventoryDetail',
          component: resolve => require(['../pages/Main/Facility/User/CsmbInventory/show'], resolve),
          meta: {
            auth: true, title: '盘点详情'
          }
        },
        {
          path: '/csmb_direct_detail/:id',
          name: 'CsmbDirectDetail',
          component: resolve => require(['../pages/Main/Facility/CsmbDirectDetail'], resolve),
          meta: {
            auth: true, title: '直购申请明细'
          }
        },
        {
          path: '/csmb_detail/:id',
          name: 'CsmbDetail',
          component: resolve => require(['../pages/Main/Facility/CsmbDetail'], resolve),
          meta: {
            auth: true, title: '耗材明细'
          }
        },
        {
          path: '/facility/storeroom/csmb_query',
          name: 'StoreroomCsmbQuery',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbQuery'], resolve),
          meta: {
            auth: true, title: '库存查询'
          }
        },
        {
          path: '/facility/storeroom/csmb_inventory',
          name: 'StoreroomCsmbInventory',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbInventory'], resolve),
          meta: {
            auth: true, title: '盘点'
          }
        },
        {
          path: '/facility/storeroom/csmb_inventory/add',
          name: 'StoreroomCsmbInventoryAdd',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbInventory/add'], resolve),
          meta: {
            auth: true, title: '新的盘点'
          }
        },
        {
          path: '/facility/storeroom/csmb_inventory/check/:id/:batchId/:consumableId',
          name: 'StoreroomCsmbInventoryCheck',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbInventory/check'], resolve),
          meta: {
            auth: true, title: '库房盘点'
          }
        },
        {
          path: '/facility/storeroom/csmb_inventory/:id',
          name: 'StoreroomCsmbInventoryDetail',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbInventory/show'], resolve),
          meta: {
            auth: true, title: '盘点详情'
          }
        },
        {
          path: '/facility/storeroom/csmb_in',
          name: 'StoreroomCsmbIn',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbIn'], resolve),
          meta: {
            auth: true, title: '入库记录'
          }
        },
        {
          path: '/facility/storeroom/csmb_out',
          name: 'StoreroomCsmbOut',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbOut'], resolve),
          meta: {
            auth: true, title: '出库记录'
          }
        },
        {
          path: '/facility/storeroom/csmb_remind',
          name: 'StoreroomCsmbRemind',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbRemind'], resolve),
          meta: {
            auth: true, title: '过期提醒'
          }
        },
        {
          path: '/facility/storeroom/csmb_remind/:id',
          name: 'CsmbBatchRemind',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbRemind/CsmbBatchRemind'], resolve),
          meta: {
            auth: true, title: '过期批次'
          }
        },
        {
          path: '/facility/storeroom/csmb_purchase',
          name: 'StoreroomCsmbPurchase',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbPurchase'], resolve),
          meta: {
            auth: true, title: '库房入库'
          }
        },
        {
          path: '/facility/storeroom/purchase/csmb_batch_approval/:id',
          name: 'CsmbBatchApproval',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbPurchase/CsmbBatchApproval'], resolve),
          meta: {
            auth: true, title: '未确认批次'
          }
        },
        {
          path: '/facility/storeroom/csmb_direct',
          name: 'StoreroomCsmbDirect',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbDirect'], resolve),
          meta: {
            auth: true, title: '直购入库'
          }
        },
        {
          path: '/facility/storeroom/csmb_direct/batch_approval/:id',
          name: 'CsmbDirectBatchApproval',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbDirect/CsmbDirectBatchApproval'], resolve),
          meta: {
            auth: true, title: '未确认直购批次'
          }
        },
        {
          path: '/facility/storeroom/csmb_temporary',
          name: 'StoreroomCsmbTemporary',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbTemporary'], resolve),
          meta: {
            auth: true, title: '寄销库存'
          }
        },
        {
          path: '/facility/storeroom/csmb_consign',
          name: 'StoreroomCsmbConsign',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbConsign'], resolve),
          meta: {
            auth: true, title: '寄销收货'
          }
        },
        {
          path: '/facility/user/csmb_temporary',
          name: 'DeptCsmbTemporary',
          component: resolve => require(['../pages/Main/Facility/User/CsmbTemporary'], resolve),
          meta: {
            auth: true, title: '寄销库存'
          }
        },
        {
          path: '/facility/user/csmb_consign',
          name: 'DeptCsmbConsign',
          component: resolve => require(['../pages/Main/Facility/User/CsmbConsign'], resolve),
          meta: {
            auth: true, title: '寄销收货'
          }
        },
        {
          path: '/facility/storeroom/csmb_consign/csmb_consign_approval/:id',
          name: 'CsmbConsignApproval',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbConsign/CsmbConsignApproval'], resolve),
          meta: {
            auth: true, title: '寄销入库'
          }
        },
        {
          path: '/facility/user/csmb_consign/csmb_consign_approval/:id',
          name: 'DeptCsmbConsignApproval',
          component: resolve => require(['../pages/Main/Facility/User/CsmbConsign/DeptCsmbConsignApproval'], resolve),
          meta: {
            auth: true, title: '寄销入科'
          }
        },
        {
          path: '/user',
          name: 'User',
          component: resolve => require(['../pages/Main/User'], resolve),
          meta: {
            auth: true /* 是否需要认证 */, title: '我的', hideBack: true
          }
        },
        {
          path: '/user/password_reset',
          name: 'PasswordReset',
          component: resolve => require(['../pages/Main/User/PasswordReset'], resolve),
          meta: {
            auth: true, title: '重置密码'
          }
        },
        {
          path: '/facility/user/csmb_consign/csmb_consign_batch/:id',
          name: 'DeptCsmbConsignBatch',
          component: resolve => require(['../pages/Main/Facility/User/CsmbConsign/DeptCsmbConsignBatch'], resolve),
          meta: {
            auth: true, title: '寄销入科'
          }
        },
        {
          path: '/facility/user/dept_csmb_use/use_batch/:batchId/:deptId',
          name: 'DeptCsmbBatchUse',
          component: resolve => require(['../pages/Main/Facility/User/CsmbUse/UseBatch'], resolve),
          meta: {
            auth: true, title: '批次使用'
          }
        },
        {
          path: '/facility/user/scan/:id',
          name: 'DeptCsmbScan',
          component: resolve => require(['../pages/Main/Facility/User/CsmbScan'], resolve),
          meta: {
            auth: true, title: '科室寄销|科室使用'
          }
        },
        {
          path: '/facility/storeroom/additional',
          name: 'StoreroomAdditional',
          component: resolve => require(['../pages/Main/Facility/Storeroom/Additional'], resolve),
          meta: {
            auth: true, title: '主动发货'
          }
        },
        {
          path: '/facility/storeroom/csmb_application/:id',
          name: 'StoreroomCsmbApplication',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbApplication'], resolve),
          meta: {
            auth: true, title: '发货二维码'
          }
        },
        {
          path: '/facility/storeroom/batch',
          name: 'StoreroomCsmbBatch',
          component: resolve => require(['../pages/Main/Facility/Storeroom/CsmbBatch'], resolve),
          meta: {
            auth: true, title: '批次查询'
          }
        }
      ]
    },
    {
      path: '/wx_login',
      component: WxLogin
    },
    {
      path: '/get_wechat_token',
      component: WxTokenGetter
    },
    {
      path: '/logout',
      component: logout
    },
    {path: '*', redirect: '/login'}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js